import {FC} from "react";
import {Broadcast} from "../../../../lib/src/api";
import moment from "moment";
import {useNavigate} from "react-router-dom";

const titleTruncateLimit = 55
const contentTruncateLimit = 150

interface TussenOnsBroadcastCardProps {
  broadcast: Broadcast|null
  unread: boolean
}
export const TussenOnsBroadcastCard: FC<TussenOnsBroadcastCardProps> = (props) => {
  const navigate = useNavigate()
  if (props.broadcast === null) {
    return <div className={'bg-brand-background border border-brand-primary-container rounded-lg px-4 py-4'}>
      <div className={'h-12 flex items-center mb-4'}>

        <div className={'h-10 w-10 rounded-full bg-slate-200 animate-pulse mr-4'}>

        </div>

        <div className={'flex-1'}>
          <div className={'rounded-sm bg-slate-200 animate-pulse w-full'}>&nbsp;</div>
          <div className={'rounded-sm bg-slate-200 animate-pulse w-1/3 text-xs mt-1'}>&nbsp;</div>
        </div>

      </div>
      <div className={'flex items-start'}>
        <div className={'h-32 w-32 bg-slate-200 animate-pulse rounded-sm mr-4'}></div>
        <div className={'flex-1'}>
          <div className={'rounded-sm bg-slate-200 animate-pulse w-full'}>&nbsp;<br/>&nbsp;</div>
        </div>
      </div>
    </div>
  }
  return <div className={'bg-brand-background border border-brand-primary-container cursor-pointer hover:border-brand-primary rounded-lg px-4 py-4'} onClick={() => navigate(`/tussen-ons/nieuws/${props.broadcast!.id}`)}>
    <div className={'h-12 flex items-center mb-4'}>

      <img src="/img/icon_miep.png" alt="" className={'object-cover h-10 w-10 rounded-full mr-4'} />

      <div className={'flex-1'}>
        <div className={'rounded-sm font-medium'}>{props.broadcast.subject.length > titleTruncateLimit ? `${props.broadcast.subject.substring(0, titleTruncateLimit)}…` : props.broadcast.subject}</div>
        <div className={'rounded-sm text-brand-secondary text-xs mt-1'}>{moment(props.broadcast.updated_at).format('DD-MM-YYYY HH:mm')}</div>
      </div>

      {props.broadcast.is_unread && <div className={'h-6 -mt-8 ml-2 flex items-center justify-end text-xs font-medium uppercase text-blue-600'}>
        <div className={'bg-blue-600 w-2 h-2 rounded-full mr-2'}></div>
        Ongelezen
      </div>}
    </div>
    <div className={'flex items-start'}>
      <div className={'flex'}>
        {/* TODO: Image */}
        {props.broadcast.cover_image_url ? <img src={props.broadcast.cover_image_url} alt="" className={'object-cover h-32 w-32 rounded-lg mr-4'} /> : <div className={'bg-slate-200 object-cover h-32 w-32 rounded-lg mr-4'}></div>}
        <div className={'flex-1'}>
          <div className={''}>{props.broadcast.message.length > contentTruncateLimit ? props.broadcast.message.substring(0, contentTruncateLimit)+'…' : props.broadcast.message}</div>
        </div>
      </div>
    </div>
  </div>
}
